module.exports = __webpack_public_path__ + "static/media/finland-flag-round-small.44f1501c.png";